import {BaseApiTemplateService, Core2Config} from '../../shared';
import {StandardIndustrialClassificationContainer} from '../../../../../../models';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class StandardIndustrialClassificationService extends BaseApiTemplateService<StandardIndustrialClassificationContainer> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/standard-industrial-classifications/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/standard-industrial-classifications/backoffice-ep';
    this.httpClient = http;
  }

}
